<template>
  <div class="ActivityFrame main margin-Top38">
    <!-- 活动框title -->
    <DockingSystemTitle
      :title="'创新活动（云对接）'"
      :moreType="true"
      :underlineType="false"
      :titleCenter="false"
    />
    <!-- Prediction预告是否显示 -->
    <div class="Project">
      <el-row class="ProjectContent" :gutter="13" >
        <CloudDockingProject :itemData="listData"/>
        <!-- <el-col :xs="24" :sm="8" v-for="(item,index) in listData" :key="index">
        
        </el-col> -->
      </el-row>
    </div>

  </div>
</template>

<script>
import DockingSystemTitle from "@/components/DockingSystem/Title/DockingSystemTitle.vue"; //活动框title
import CloudDockingProject from "@/components/DockingSystem/ActivityFrame/CloudDockingProject.vue"; //云对接项目
export default {
  props: {
    list:Array,
  },
  components: {
    DockingSystemTitle,
    CloudDockingProject,
  },
  data() {
    return {
      listData:[],//存储内容
    };
  },
  created: function () {},
  watch:{
    list(val){
      this.listData  = val;
      console.log('val-list',val);
    }
  },
  methods: {},
};
</script>

<style scoped>
@media (max-width: 768px) {
  .ActivityFrame .Project {
    margin: 0 15px ;
  }
  .Project .ProjectContent{
    margin-top: 24px;
  }
}
.margin-Top38 {
  margin-top: 38px;
}
.ActivityFrame {
  background-color: #262525;
  border-radius: 25px;
}

.Project {
  /* display: flex;
    justify-content: space-between; */
  margin: 0 30px;
      padding-bottom: 24px;
}
.ProjectContent{
  margin-top: 48px;
}
</style>